var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "reset-main",
    attrs: {
      "ma-0": "",
      "pa-3": "",
      "row": "",
      "justify-center": "",
      "align-start": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticClass: "reset-wrapper d-flex flex-column align-stretch",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg4": "",
      "xl3": "",
      "pa-3": ""
    }
  }, [_c('div', {
    staticClass: "reset-card"
  }, [_c('h1', {
    staticClass: "reset-title"
  }, [_vm._v("Retrieve username and/or change password")]), _c('p', {
    staticClass: "reset-description"
  }, [_vm._v(" If your email exists in our database, we will send you an email with your username and a link to change your password. ")]), _c('ValidationObserver', {
    ref: "observer",
    staticClass: "reset-form d-flex flex-column",
    attrs: {
      "tag": "div"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var invalid = _ref.invalid;
        return [_c('ValidationProvider', {
          attrs: {
            "rules": "required|email",
            "name": "Email"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errors = _ref2.errors;
              return [_c('v-text-field', {
                attrs: {
                  "label": "Email",
                  "outlined": "",
                  "dense": "",
                  "error": errors.length > 0,
                  "error-messages": errors[0]
                },
                model: {
                  value: _vm.email,
                  callback: function ($$v) {
                    _vm.email = $$v;
                  },
                  expression: "email"
                }
              })];
            }
          }], null, true)
        }), _c('v-btn', {
          staticClass: "reset-btn",
          attrs: {
            "type": "submit",
            "loading": _vm.loading,
            "disabled": _vm.submitted && invalid || _vm.loading
          },
          on: {
            "click": function ($event) {
              return _vm.onReset();
            }
          }
        }, [_vm._v("Send Email")])];
      }
    }])
  }), _c('router-link', {
    staticClass: "reset-back-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    },
    on: {
      "click": _vm.clearToasted
    }
  }, [_c('v-icon', {
    staticClass: "back-arrow",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Back to Login ")], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }